import { useQuery } from "@tanstack/react-query";

import api from "./apiClient";

import cookiesHelper from "../helpers/cookies";

import { IModuleWithFeatureAndSubscription } from "../interfaces/services";

export const useGetSubscribedModuleFeatures = () => {
    const queryFn = async (): Promise<IModuleWithFeatureAndSubscription[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`subscribed-module-features/school/immersion/0/no-domain`);
        return res.data?.length ? res.data : [];
    };

    return useQuery({
        queryKey: ['subscribed_module_features'],
        queryFn,
        retry: 0,
    });
};